import { useState, useEffect } from 'preact/hooks';
import './ProductCarousel.less';
import { Product } from '../../models/Product';
import ProductCard from '../../components/product/card/ProductCard';
import Button from '../../components/button/Button';
import Icon from '../../components/icon/Icon';
import useAppDispatch from '../../hooks/useAppDispatch';
import { brilliant } from '../../api';
import { useTranslation } from '../../hooks/useTranslation';
import Carousel from '../../components/carousel/Carousel';

export type ProductCarouselProps = {
    quantityVisible?: number;
    productIds: string[];
    searchType: 'combination' | 'similar';
    title: string;
};

const ProductCarousel = ({
    quantityVisible = 4,
    productIds,
    searchType,
    title
}: ProductCarouselProps) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [products, setProducts] = useState<Product[]>([]);
    useEffect(() => {
        const result =
            searchType === 'similar'
                ? brilliant.getProductList({
                      queryType: 'similar',
                      similarToProductIds: productIds
                  })
                : brilliant.getProductList({
                      queryType: 'combinations',
                      combineWithProductIds: productIds
                  });
        result
            .then(products => {
                setProducts(products);
            })
            .catch(() => {});
    }, []);
    if (products.length === 0) {
        return null;
    }
    return (
        <div className={`bri-ProductCarousel`}>
            <div className="bri-ProductCarousel-header">
                <div className="bri-ProductCarousel-title bri-TitleBoldFont">
                    <Icon iconId="brilliant-logo" />
                    {title}
                </div>
                <Button
                    variant="link"
                    endIconId="arrow-right"
                    endIconSize="x-small"
                    onClick={() =>
                        dispatch.featureState.startFeature(
                            searchType === 'combination'
                                ? {
                                      featureType:
                                          'product-search-combinations',
                                      combinationWithProductIds: productIds
                                  }
                                : {
                                      featureType: 'product-search-similar',
                                      similarToProductIds: productIds
                                  }
                        )
                    }
                >
                    {t('PRODUCT_CAROUSEL_VIEW_MORE_BUTTON_LABEL')}
                </Button>
            </div>
            <Carousel
                items={products.map(product => (
                    <ProductCard
                        key={product.id}
                        product={product}
                        animationDelay={0}
                        source="web"
                        featureType={
                            searchType === 'combination'
                                ? 'product-search-combinations'
                                : 'product-search-similar'
                        }
                    />
                ))}
                stepSize={quantityVisible}
                visibleItems={quantityVisible}
            />
        </div>
    );
};

export default ProductCarousel;
